module.exports = __webpack_public_path__ + "media/images/curve_wheel-a04e4d84a6e57458644d48acccd1c327.png";